import React from 'react'

import Layout from '../Layout'
import AuctionView from '../../../utils/CommonFunctionality/LiveLots/AuctionView'

const LiveAuctionView = (props) => {
    return (
        <Layout props={props}>
            <div className="customContainer pt-3 auctionCnt">
                <AuctionView {...props} />
            </div>
        </Layout>
    )
}

export default LiveAuctionView
